<template>
    <div class="popup" v-if="backupLogsShow">
         <div class="content" id='viewBackupLogs'>
               <div class="title">
                 <span >{{$t('language.popup.taskListPopup.viewLogs')}}</span>
                
                 <div class="icon white-close dialog-close" @click="closePage()"></div>
               </div>
                <!-- 默认加载界面 -->
               <div v-if="loading" class="backupBody" v-loading="loading">
               </div>
               <div v-else class="backupBody">
                   <span v-if="!nonFlag">
                    <div></div>
                    <div class="sync_detail" v-if="viewDetail && viewDetail.tasks[0] &&(viewDetail.tasks[0].tranferWay=='backup' || viewDetail.tasks[0].tranferWay=='retry-backup')" >{{$t('language.cloudBackup.backupDetails')}}</div>
                    <div class="sync_detail" v-else>{{$t('language.cloudBackup.restoreDetails')}}</div>
                    <div :class="toItemExist?'catalog':'not-catalog'">
                       <div class="log-line" v-if="viewDetail.tasks[0].tranferWay=='backup' || viewDetail.tasks[0].tranferWay=='retry-backup'">
                       <div class="detail_txt"> {{$t('language.cloudBackup.backup')}}: </div> 
                       <div v-if="!viewDetail.tasks[0].fromItem.data" class="backup-category-link" style="lineHeight:18Px;float:left;"  :title="viewDetail.tasks[0].fromItem.nodes|getCatalog|getCatalogTitle" @click.stop="toSourceCatalog(viewDetail.tasks[0].fromItem)">
                           {{viewDetail.tasks[0].fromItem.nodes|getCatalog}}
                       </div>
                       <div v-if="viewDetail.tasks[0].fromItem.data" class="backup-category-link" style="lineHeight:18Px;float:left;"  :title="viewDetail.tasks[0].fromItem.data[0].nodes|getCatalog|getBackupInfo" @click.stop="openSource(viewDetail.tasks[0].fromItem)">
                           {{viewDetail.tasks[0].fromItem.data[0].nodes|getCatalog|getBackupInfo}} 
                       </div>
                       </div>
                       <!-- 显示还原的源 -->
                       <div class="log-line" v-else>
                             <div class="detail_txt"> {{$t('language.cloudBackup.restore')}}: </div> 
                              <div v-if="!viewDetail.tasks[0].toItem.data" class="backup-category-link" style="lineHeight:18Px;float:left;"  :title="viewDetail.tasks[0].toItem.nodes|getCatalog" @click.stop="toRestoreSource(viewDetail.tasks[0])">
                                 {{viewDetail.tasks[0].toItem.nodes|getCatalog}} 
                             </div>
                              <div v-else class="backup-category-link" style="lineHeight:18Px;float:left;"  :title="viewDetail.tasks[0].toItem.nodes|getCatalog|getBackupInfo" @click.stop="openSource(viewDetail.tasks[0].toItem)">
                                 {{viewDetail.tasks[0].toItem.nodes|getCatalog|getBackupInfo}} 
                             </div>

                       </div>
                       <!-- 备份任务目标 -->
                       <div v-if="viewDetail.tasks[0].tranferWay=='backup' || viewDetail.tasks[0].tranferWay=='retry-backup'">
                       <div class="log-line">
                        <!-- 显示目标目录 -->
                       <div class="detail_txt">{{$t('language.common.to')}}: </div>  <div class="backup-category-link"  style="lineHeight:18Px;float:left;" :title="viewDetail.tasks[0].toItem.nodes|getCatalog|getCatalogTitle" @click.stop="toAimCatalog(viewDetail.tasks[0].toItem)">{{viewDetail.tasks[0].toItem.nodes|getCatalog}}</div>
                       </div>
                       
                       </div>
                       <!-- 还原目标 -->
                       <div v-else>
                            <!-- 还原到新位置 -->
                             <div class="log-line"  v-if="viewDetail.tasks[0].lastLog.restoreInfo.restoreNew">
                                  <div class="detail_txt">{{$t('language.common.to')}}: </div>  
                                  <div  v-if="viewDetail.tasks[0].lastLog.restoreInfo" class="backup-category-link"  style="lineHeight:18Px;float:left;" :title="viewDetail.tasks[0].lastLog.restoreInfo.toItems[0].nodes|getCatalog|getCatalogTitle" @click.stop="toAimCatalog(viewDetail.tasks[0].lastLog.restoreInfo.toItems[0])">{{viewDetail.tasks[0].lastLog.restoreInfo.toItems[0].nodes|getCatalog}}</div>
                             </div>
                             <!-- 还原到原位置 -->
                             <div class="log-line" v-else>
                                 <!-- 如果还原任务是单源 -->
                                 <div v-if="!viewDetail.tasks[0].fromItem.data">
                                     <div class="detail_txt">{{$t('language.common.to')}}: </div>  <div class="backup-category-link"  style="lineHeight:18Px;float:left;" title="Original" @click.stop="toAimCatalog(viewDetail.tasks[0].fromItem)">Original</div>
                                 </div>
                                 <!-- 如果还原任务是单源 -->
                                 <div v-else>
                                     <div class="detail_txt">{{$t('language.common.to')}}: </div>  <div class="backup-category-link"  style="lineHeight:18Px;float:left;" title="Original" @click.stop="openRestoreAim(viewDetail.tasks[0].fromItem)">Original</div>
                                 </div>
                             </div>
                       </div>
                    </div>
                    </span>
                    <div class="detail_txt" v-if="nonFlag">{{$t('language.cloudSync.notRun')}}</div>
                    <div v-else style="color:#6f7886;lineHeight:18Px;width:100%;height:75Px;marginBottom:15Px;">
                             <div class="log-line" v-if="showStatus(viewDetail.tasks[0])=='failure'">
                    {{$t('language.common.result')}}: {{$t('language.common.failure')}}
                </div>
                <div class="log-line" v-if="showStatus(viewDetail.tasks[0])=='partialSuccess'">
                    {{$t('language.common.result')}}: {{$t('language.common.partialSuccess')}}
                </div>
                <div class="log-line" v-if="showStatus(viewDetail.tasks[0])=='success'">
                    {{$t('language.common.result')}}: {{$t('language.common.success')}}
                </div>
                 <div class="log-line" v-if="showStatus(viewDetail.tasks[0])=='cancel'">
                    {{$t('language.common.result')}}: {{$t('language.common.canceled')}}
                </div>
                     <span v-if="toItemExist">
                        <div class="log-line">
                            <div class="log-backupline-left" >
                        {{$t('language.common.fileProcess')}}: {{viewDetail.tasks[0].lastLog.readyTranFileCount}}/{{viewDetail.tasks[0].lastLog.totalFileCount}}
                            </div>
                             <div class="log-line-right">
                        {{$t('language.common.dataProcess')}}:{{viewDetail.tasks[0].lastLog.fileTotalReadedBytes|formatByte}}/{{viewDetail.tasks[0].lastLog.totalBytes|formatByte}}        
                             </div>    
                        </div>
                        <div class="log-line">
                             <div class="log-backupline-left">
                                {{$t('language.common.startTime')}}: {{viewDetail.tasks[0].lastLog.taskStartTime|transferForMatTime}}
                             </div>
                             <div class="log-line-right">
                                {{$t('language.common.endTime')}}: {{viewDetail.tasks[0].lastLog|getEndTime}}
                             </div>
                        </div>
                        <div class="log-line">
                             <div class="log-backupline-left">
                               {{$t('language.common.averageRateSpecial')}}:<span :title="getAvgSpeed(viewDetail.tasks[0])"> {{(viewDetail.tasks[0].lastLog.fileTotalReadedBytes/(viewDetail.tasks[0].lastLog.taskElaspedTimeLong/1000))|formatByteSpeed}}</span>
                             </div>
                        </div>
                      </span>
                      <div v-else style="color:#000;font-size:16Px;position:relative;top:20px;">
                          <span v-if="errorReason=='backupInitConfigFail'">
                           {{$t('language.cloudBackup.notFoundAim')}}
                           </span>
                           <span v-else>
                            {{$t('language.cloudBackup.backupNotWork')}}
                           </span>
                      </div>
                    </div>
                        <div class="log-line" v-if="viewDetail.tasks[0].lastLog&&viewDetail.tasks[0].lastLog.errorList &&viewDetail.tasks[0].lastLog.errorList.length&&showStatus(viewDetail.tasks[0])!='cancel'">
                               <div class="log-backupline-left click-log-red" @click="openFailedFiles()"> {{$t('language.common.viewFailed')}}</div>
                               <div style="color:#4a81ff" class="retryBackUp" @click="retry()">{{$t('language.common.retryAll')}}</div>
                        </div>
                        <div class="log-line" v-if="showStatus(viewDetail.tasks[0])=='failure'&& viewDetail.tasks[0].lastLog&&( !viewDetail.tasks[0].lastLog.errorList || !viewDetail.tasks[0].lastLog.errorList.length)">
                               <div class="log-backupline-left click-log-red" @click="openFailedFiles()"> {{$t('language.common.viewFailed')}}</div>
                               <div style="color:#4a81ff" class="retryBackUp" @click="retry()">{{$t('language.common.retryAll')}}</div>   
                        </div>
                        <div class="log-line" v-if="viewDetail.tasks[0].lastLog && ((viewDetail.tasks[0].lastLog.errorList && viewDetail.tasks[0].lastLog.errorList.length)|| (!viewDetail.tasks[0].lastLog.errorList.length || !viewDetail.tasks[0].lastLog.errorList)) && !viewDetail.tasks[0].lastLog.error"  style="color:#6f7886;">
                              <div  class="log-backupline-left" style="position:relative;margin-top:10Px" v-if="showStatus(viewDetail.tasks[0])=='success'">
                                   <div v-if="viewDetail.tasks[0].tranferWay=='backup' || viewDetail.tasks[0].tranferWay=='retry-backup'">
                                   {{$t('language.cloudBackup.successBck')}}
                                   </div>
                                   <div v-else>
                                     {{$t('language.cloudBackup.successRestore')}}
                                   </div>
                              </div>
                              <div  class="log-backupline-left" style="position:relative;margin-top:10Px"  v-if="showStatus(viewDetail.tasks[0])=='cancel'">
                                   {{$t('language.cloudBackup.taskCanceled')}}
                              </div>
                              <!-- <div style="color:#4a81ff"  class="log-backupline-left retryBackUp"  @click="retry()" v-if="showStatus(viewDetail.tasks[0])=='failure'">
                                   Retry All
                              </div> -->

                        </div>
                        
               </div>
              

         </div>
    </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
import selectDialog from "@/components/common/select/task_list_select";
export default {
  data: function () {
    return {
      backupLogsShow: false,
      viewDetail: {},
      nonFlag: false,
      loading: false,
      toItemExist:true,
      errorReason:null
    }
  },
  watch:{
     backupLogsShow(newValue,oldValue){
        //console.log(this.viewDetail);
     }
  },
  components:{
      "task-list-select": selectDialog,
  },
  methods: {
    getDataProcessTitle (value) {
      let str1 = commonUtils.formatByte(value.lastLog.fileTotalReadedBytes);
      let str2 = commonUtils.formatByte(value.lastLog.totalBytes);
      return str1 + '/' + str2;
    },
    closePage () {
      this.backupLogsShow = false;
    },
    toAimCatalog (item) {
      this.$parent.toAimCatalog(item);
    },
    toSourceCatalog (item) {
      this.$parent.toSourceCatalog(item);
      
    },
    toRestoreSource(item){
      var itemCopy = Object.assign({},item);
       var data={
           fileId:item.backupRoot.fileId,
           filename:item.backupRoot.filename
       }
       itemCopy.toItem.fileId = data.fileId;
       itemCopy.toItem.filename = data.filename;
       var nodes = Object.assign([],item.toItem.nodes);
       var nodesCopy = Object.assign([],item.toItem.nodes);   
       var toItemCopy =   Object.assign({},item.toItem);  
       var fileId = item.backupRoot.fileId;
       var arr = fileId.split('/');
       var nodeNameArr = [];
       for(var i = 0;i < arr.length; i++){
           var element = arr[i];
           for(var j = 0;j < nodes.length; j++){
             var node = nodes[j];
             nodeNameArr.push(node.filename);
           }
           if(element && !nodeNameArr.includes(element)){
                 var data = {
                 fileId:nodes[0].fileId+'/'+element,
                 filename:element
                 }
                 nodesCopy.unshift(data);
           }
       }
       toItemCopy.nodes = nodesCopy;
       this.$parent.toSourceCatalog(toItemCopy);
    },
    openFailedFiles () {
      let that = this;
      let failedFilesDialog = this.$parent.$refs.failedFilesDialog;
      let errorList = this.viewDetail.tasks[0].lastLog.errorList;
      let task = that.viewDetail.tasks[0];
      failedFilesDialog.transferType = this.viewDetail.type;
      failedFilesDialog.selectedArr = [];
      failedFilesDialog.unfinishData = Object.assign([], errorList);
      $.each(failedFilesDialog.unfinishData, function (index, item) {
        item.fromItem = Object.assign([], task.fromItem);
        item.toItem = Object.assign([], task.toItem);
        item.options = task.options;
      });
      that.$forceUpdate();
      failedFilesDialog.retryFailedShow = true;
    },
    getAvgSpeed (value) {
      let interval = (value.lastLog.fileTotalReadedBytes / (value.lastLog.taskElaspedTimeLong / 1000));
      return this.Utils.formatByteSpeed(interval);
    },
    getMultiSourceCatalog(task){
        let catalogArr = [];
        $.each(task.fromItem.data, function (i, item) {
            let catalogMultName = commonUtils.getCatalog(item.nodes);
            let catalogMult = {
                catalog: catalogMultName,
                fromItem: item
              }
            catalogArr.push(catalogMult);
       });
        return catalogArr;
    },
    showStatus(item){
    let result=taskListUtils.showStatus(item);
    return result;
    },
    openSource(data){
     this.$parent.$parent.$refs.backupSourceFilesDialog.viewBackupShow=true;
     this.$parent.$parent.$refs.backupSourceFilesDialog.sourceData=data;
    },
    //打开还原目标（多目录）
    openRestoreAim(data){
      this.$parent.$parent.$refs.restoreAimMoreDialog.viewBackupShow=true;
      this.$parent.$parent.$refs.restoreAimMoreDialog.sourceData=data;
    },
    //重试一个云备份任务
    retry(){
        //console.log(this.$parent.item);
        var item =Object.assign({},this.$parent.item);
        var tw;
        if(item.tranferWay == "backup" || item.tranferWay == "retry-backup"){
            tw='retry-backup';
        }else{
            tw='retry-restore';
        }
        var that=this;
        var retryData= new taskListUtils.executeRestoreData(item.userId,item.type,item.id,tw,item.lastVersionNum,[item.toItem],[item.fromItem],item.options);
          this.Utils.doTasksRequest("execute",retryData).then(result => {
                if(result.status==200){
                    that.$parent.$parent.tasklistData[that.$parent.index].status='Running';
                    that.backupLogsShow=false;
                    that.$parent.initTask();
                    that.$parent.$parent.$forceUpdate();
                    var progressData = new taskListUtils.progressData(commonUtils.getUser().id, item.type, item.id, item.workId);
                    that.$parent.getBackupSingleProgressDetail(that.$parent.item,progressData,that.$parent.index);
                }else{
                  if(!item.toItem.length){
                      that.$toast({
                        text: that.$t('language.common.failedEmptyTip'),
                        type: 'fail',
                        idValue: "rightBodyList"
                      });
                  }
                }
          });
    }
  }
}
</script>

<style>
#viewBackupLogs {
  width: 500Px;
  /*no*/
  height: 300Px;
  /*no*/
  font-size: 12Px;
}
.backupBody {
  padding: 15Px;
  /*no*/
  width: 100%;
  height: calc(100% - 40Px);
  /*no*/
  box-sizing: border-box;
}
.sync_detail {
  font-weight: bold;
  font-size: 14Px !important;
  margin-bottom: 20Px;
}
.detail_txt {
  font-size: 14Px;
  color: #6f7886;
  margin-bottom: 5Px;
  float: left;
}
.catalog {
  margin-bottom: 20Px;
  width: 100%;
  height: 40Px;
}
.not-catalog{
  width: 100%;
  height: 40Px;
}
.log-line {
  width: 100%;
  float: left;
}
.backup-category-link {
  color: #4281ff;
  float: left;
  max-width: 400Px;
  /*no*/
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.view-backup-category-link {
  color: #4281ff;
  float: left;
  width: 160Px;
  /*no*/
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.backup-category-link:hover,
.view-backup-category-link:hover {
  color: #4281ff;
  text-decoration: underline;
  cursor: pointer;
}
.log-backupline-left {
  float: left;
  width: 255Px;
  /*no*/
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.retryBackUp:hover{
    text-decoration: underline;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/view_backup_logs_popups.vue